/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {executeUserOp} from '../api'

export const useMutationExecuteUserOp = createReactQueryMutationHook('executeUserOp', executeUserOp)
